import { Component, inject } from '@angular/core';
import { SeoService } from '../../core/services/seo.service';
import { LegalLayoutComponent } from './legal-layout.component';

@Component({
  selector: 'app-impressum',
  standalone: true,
  imports: [LegalLayoutComponent],
  templateUrl: './impressum.component.html',
})
export class ImpressumComponent {
  constructor() {
    inject(SeoService).apply({
      title: 'Impressum · Craftly',
      description: 'Anbieterkennzeichnung und Kontaktdaten der Craftly-Plattform gemäß § 5 TMG.',
      path: '/impressum',
      type: 'article',
    });
  }
}
